<template>
	<div class="einladung">
		<h1>Einladung</h1>
		<p><v-text-field id="kennung" label="Gruppenkennung" v-model="gruppe" :error-messages="errors" :background-color="kennungFarbe" prepend-inner-icon="mdi-fingerprint"></v-text-field></p>
		<h2>Link zur Einladung</h2>
		<p><a :href="urlEinladung">{{urlEinladung}}</a></p>
		<h2>Link zur Auswertung</h2>
		<p><a :href="urlAuswertung">{{urlAuswertung}}</a></p>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'einladung',
		components: {

		},
		data: function () {
			return {
				// teilnehmer: String,
				gruppe: String,
				pruefung: String,
				kennungFarbe: '#ffffff',
				kennungSperre: true,
				errors: [],
				urlEinladung: String,
				urlAuswertung: String
			}
		},
		mounted() {
			this.gruppe = this.zufallskennung();
			// this.$teilnehmer = 'j874y0asdsadsad';
		},
		methods: {
			zufallskennung: function(laenge, zeichen) {
				laenge = laenge || 8;
				zeichen = zeichen || '0123456789abcdefghijkmnopqrstuvwxyz';
				var zeichenfolge = '';
				for (var i = 0; i < laenge; i++) {
					var position = Math.floor(Math.random() * zeichen.length);
					zeichenfolge += zeichen.substring(position,position+1);
				}
				return zeichenfolge;
			}
		},
		computed: {
			teilnehmer() {
				return this.$store.state.teilnehmer;
			}
		},	
		watch: {
			async gruppe(gruppe) {
				this.kennungFarbe = '#ffffff';
				this.kennungSperre = true;
				this.urlEinladung = '';
				this.urlAuswertung = '';
				var sonderzeichen = /[^a-zA-Z0-9]/;
				if (gruppe.length == 0) {
					this.errors = ['Die Gruppenkennung darf nicht leer sein!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (gruppe.length < 8) {
					this.errors = ['Die Gruppenkennung muss acht oder mehr Zeichen umfassen!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (gruppe.length > 16) {
					this.errors = ['Die Gruppenkennung darf nicht mehr als 16 Zeichen umfassen!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (gruppe.indexOf(" ") !== -1) {
					this.errors = ['In der Gruppenkennung sind keine Leerzeichen erlaubt!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (sonderzeichen.test(gruppe) == true) {
					this.errors = ['Die Gruppenkennung darf nur Buchstaben und Ziffern enthalten; Sonderzeichen sind nicht erlaubt!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else if (gruppe.indexOf(" ") !== -1) {
					this.errors = ['In der Gruppenkennung sind keine Leerzeichen erlaubt!'];
					this.kennungFarbe = '#ffeeee';
					this.kennungSperre = true;
				}
				else {
					this.errors = ['Überprüfung auf Duplikate läuft...'];
					try {
						const response = await axios.get('https://www.arbeitsverdichtung.de/api/gruppenkennung', {
							params: {
								gruppe: gruppe
							}
						});
						const data = await response;
						if (Number.parseInt(data.data) == 0) {
							// return true;
							this.errors = [];
							this.kennungFarbe = '#eeffee';
							this.kennungSperre = false;
							var href = window.location.href;
							this.urlEinladung = href.substr(0, href.length - 9) + '?e=avki&b=' + this.gruppe;
							this.urlAuswertung = href.substr(0, href.length - 9) + 'auswertung?a=' + this.teilnehmer + '&b=' + this.gruppe;
						} else {
							this.errors = ['Die Kennung ist bereits vorhanden!'];
							this.kennungFarbe = '#ffeeee';
							this.kennungSperre = true;
							this.urlEinladung = '';
							this.urlAuswertung = '';
						}
					} catch (error) {
						alert(error);
					}
				}
			}
		}
	}
</script>
<style scoped>
	#kennung {
		font-size: 1.5em;
	}
</style>

